export default __webpack_public_path__ + "4df2dff3fa46e60e68e966a1b12ed6ea.png";